import React, { useState, useEffect } from "react";

const recomendaciones = {
  flores: percent => {
    if (percent < 10) return 'Esto fue un bajo retorno. Quizás probar aumentando la humedad te servirá. Te recomiendo catalogar en tu bitácora esta variedad y su genotipo/fenotipo como un tipo no compatible con este método de extracción. ¡No todo está perdido! Puedes intentar extraer Dry Sift o Bubble Hash y volver a prensar.';
    if (percent >= 10 && percent < 14) return 'Un retorno decente, es lo común que la mayoría suele obtener al prensar sus variedades. Cataloga siempre en la bitácora, enfocándote más en la calidad de terpenos.';
    if (percent >= 14 && percent < 18) return '¡Buen retorno! Esta variedad destaca sobre las demás. Recuerda registrar los detalles en tu bitácora.';
    if (percent >= 18 && percent < 25) return '¡Excelente retorno! Felicitaciones, te invitamos a registrar en tu bitácora esta variedad como productora.';
    if (percent >= 25) return '¡DIGNO DE DIOSES! Esta variedad fue hecha para hacer y ser rosin. Anótala en tu bitácora para nunca perderla de vista.';
    return null;
  },
  drysift: percent => {
    if (percent < 20) return 'Es un bajo retorno. Te recomendamos verificar la humedad de tu materia vegetal y aplicar más presión, compactando bien la materia dentro de la malla. Cataloga este resultado en tu bitácora. No intentes embellecer lo que no se puede.';
    if (percent >= 20 && percent < 40) return 'Buen retorno, esperado para una extracción de Dry Sift dentro de lo común.';
    if (percent >= 40 && percent < 60) return '¡Buen retorno de ese Dry Sift! Una variedad digna de dejar destacada en tu bitácora.';
    if (percent >= 60 && percent < 70) return '¡Excelente retorno! Digno de quedar registrado junto a los aprietes más destacados de tu bitácora.';
    if (percent >= 70) return 'No tenemos palabras para un retorno de esta magnitud desde Dry Sift. ¡Estás frente a una variedad que debería ser galardonada como productora de productoras!';
    return null;
  },
  bubble: percent => {
    if (percent < 40) return 'Retorno bajo. Te recomendamos catalogar esta variedad como no adecuada para Live Rosin. ¡Recuerda que tu bitácora es para eso!';
    if (percent >= 40 && percent < 60) return '¡Excelente retorno! Lo esperado para un prensado de Bubble Hash. Este es un camino largo y existen variedades que te sorprenderán aún más.';
    if (percent >= 60 && percent < 80) return '¡Muy buen retorno! Felicidades, nos imaginamos la emoción de esos resultados. Anótalos en la bitácora como una variedad óptima para Live Rosin.';
    if (percent >= 80) return '¡Estamos frente a una variedad que muestra toda su expresión de productora! Fue un largo trabajo y aquí está tu resultado. ¡Guárdalo con medallas en tu bitácora!';
    return null;
  }
};

export default function Retorno() {
  const [tipo, setTipo] = useState("flores");
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [percent, setPercent] = useState("");
  const [error, setError] = useState("");
  const [historial, setHistorial] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [isValidPercent, setIsValidPercent] = useState(false);

  // Cargar historial del localStorage
  useEffect(() => {
    const savedHistorial = localStorage.getItem('retornosHistorial');
    if (savedHistorial) {
      setHistorial(JSON.parse(savedHistorial));
    }
  }, []);

  // Guardar en localStorage cuando el historial cambia
  useEffect(() => {
    localStorage.setItem('retornosHistorial', JSON.stringify(historial));
  }, [historial]);

  const handleSubmit = e => {
    e.preventDefault();
    
    if (!input || !output) {
      setError("Por favor ingresa ambos valores");
      return;
    }

    const entrada = parseFloat(input);
    const salida = parseFloat(output);
    
    if (isNaN(entrada) || isNaN(salida) || entrada <= 0 || salida <= 0) {
      setError("Los valores deben ser números positivos");
      return;
    }
    
    if (salida > entrada) {
      setError("El peso de salida no puede ser mayor al de entrada");
      return;
    }

    const porcentaje = (salida / entrada) * 100;
    setPercent(porcentaje.toFixed(2));
    setError("");
    setMensaje(recomendaciones[tipo](porcentaje) || "");
    setIsValidPercent(true);

    // Agregar al historial
    const nuevoRegistro = {
      fecha: new Date().toLocaleString(),
      tipo: tipo === 'flores' ? 'Flores' : tipo === 'drysift' ? 'Dry Sift' : 'Bubble Hash',
      entrada: entrada,
      salida: salida,
      retorno: porcentaje.toFixed(2)
    };

    setHistorial(prev => [nuevoRegistro, ...prev].slice(0, 10)); // Mantener solo los últimos 10 registros
  };

  const handleReset = () => {
    setInput("");
    setOutput("");
    setPercent("");
    setError("");
    setMensaje("");
    setIsValidPercent(false);
  };



  return (
    <React.Fragment>
      <div className="page-content" style={{
        maxWidth: 800,
        margin: '0 auto',
        paddingBottom: 350,
        paddingTop: '2em',
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #000000 0%, #1a1a1a 100%)'
      }}>
        <h1 className="page-title">Calculadora de Retorno</h1>
      
      <form onSubmit={handleSubmit} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
        background: '#fffbe6',
        padding: 24,
        borderRadius: 14,
        boxShadow: '0 2px 8px #ffe082',
        width: '100%',
        maxWidth: 500
      }}>
        <label style={{ fontWeight: 600 }}>
          Tipo de extracción:
          <select 
            value={tipo} 
            onChange={e => setTipo(e.target.value)}
            style={{
              marginTop: 8,
              display: 'block',
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ddd'
            }}
          >
            <option value="flores">Flores</option>
            <option value="drysift">Dry Sift</option>
            <option value="bubble">Bubble Hash</option>
          </select>
        </label>

        <label style={{ fontWeight: 600 }}>
          Peso de entrada (g):
          <input
            type="number"
            min="0"
            step="0.01"
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="Ej: 10.5"
            style={{
              marginTop: 8,
              display: 'block',
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ddd'
            }}
          />
        </label>

        <label style={{ fontWeight: 600 }}>
          Peso de salida (g):
          <input
            type="number"
            min="0"
            step="0.01"
            value={output}
            onChange={e => {
              const entrada = parseFloat(input);
              const salida = parseFloat(e.target.value);
              if (!isNaN(entrada) && !isNaN(salida) && salida > entrada) {
                setError("El peso de salida no puede ser mayor al de entrada");
              } else {
                setError("");
                setOutput(e.target.value);
              }
            }}
            placeholder="Ej: 1.5"
            style={{
              marginTop: 8,
              display: 'block',
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ddd'
            }}
          />
        </label>

        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          <button
            type="submit"
            style={{
              flex: 1,
              padding: '12px',
              background: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Calcular
          </button>
          <button
            type="button"
            onClick={handleReset}
            style={{
              padding: '12px',
              background: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Limpiar
          </button>
        </div>
      </form>

      {error && (
        <div style={{
          color: '#d32f2f',
          background: '#ffebee',
          padding: '12px',
          borderRadius: '4px',
          width: '100%',
          maxWidth: 500,
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}

      {isValidPercent && (
        <div style={{
          marginTop: 24,
          background: '#fff',
          borderRadius: 12,
          padding: 18,
          boxShadow: '0 1px 6px #ffe082',
          width: '100%',
          maxWidth: 500
        }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <h3 style={{ color: '#4caf50', margin: '0 0 8px' }}>Resultado</h3>
            <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#333' }}>
              {percent}% de retorno
            </div>
          </div>
          
          {mensaje && (
            <div style={{
              marginTop: 16,
              padding: '12px',
              background: '#e8f5e9',
              borderRadius: '4px',
              color: '#2e7d32',
              fontSize: '0.9em'
            }}>
              {mensaje}
            </div>
          )}
        </div>
      )}

      {historial.length > 0 && (
        <div style={{
          marginTop: 24,
          background: '#fffbe6',
          borderRadius: 12,
          padding: 18,
          boxShadow: '0 1px 6px #ffe082',
          width: '100%',
          maxWidth: 500
        }}>
          <h3 style={{ color: '#ff9800', marginBottom: 12 }}>Historial de Retornos</h3>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {historial.map((item, index) => (
              <div key={index} style={{
                background: '#fff',
                padding: 12,
                marginBottom: 8,
                borderRadius: 8,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 4
                }}>
                  <span style={{ fontWeight: 600 }}>{item.tipo}</span>
                  <span style={{
                    color: '#4caf50',
                    fontWeight: 'bold'
                  }}>
                    {item.retorno}%
                  </span>
                </div>
                <div style={{ fontSize: '0.85em', color: '#666' }}>
                  <div>Entrada: {item.entrada}g | Salida: {item.salida}g</div>
                  <div style={{ fontSize: '0.8em', color: '#999' }}>{item.fecha}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}
